import React, { useEffect, useState } from 'react'
import { Select } from '@material-ui/core'
import { requestAPI } from '../../data/api.js'
import { markets } from '../../lib/markets'

export default function marketSelect({ violationId, initialMarket }) {
	const [market, setMarket] = useState(initialMarket)

	const handleMarketChanged = async (e) => {
		const market = e.target.value
		await updateMarket(violationId, market)
		setMarket(market)
	}

	return (
		<div>
			<span style={{ marginRight: '10px' }}>Market: </span>
			<Select
				native
				name='market'
				value={market || ''}
				onChange={handleMarketChanged}
			>
				<option value=''>None Selected</option>
				{markets.map((market, i) => (
					<option value={market.code} key={i}>
						{market.fullName}
					</option>
				))}
			</Select>
		</div>
	)
}

async function updateMarket(violationId, market) {
	return requestAPI(`/violations/${violationId}/market`, 'PATCH', { market })
}
